import React from 'react';
import MainLayout from 'components/layout/MainLayout';
import BlogArticle from 'components/blog/BlogArticle';
import { ASSET_PREFIX } from 'utils/constants';
import { NextSeo } from 'next-seo';
import RoundedButton from 'components/RoundedButton';
import Separator from 'components/Separator';
import { getCta } from 'utils/common';

const Article = () => {
  const IMAGE_DIRECTORY = `${ASSET_PREFIX}/images/blog/articles/travel-on-a-budget`;

  return (
    <MainLayout additionalClassName="blogPost">
      <NextSeo
        title="Travel On A Budget | Win Epic Prizes | DAYMADE"
        description="Travel on a budget by entering a holiday lottery like DAYMADE. Travel competitions can be a great way to tick off that bucket list. Read about it in our blog."
        openGraph={{
          title: 'Travel On A Budge | Win Epic Prizes | DAYMADE',
          description:
            'Travel on a budget by entering a holiday lottery like DAYMADE. Travel competitions can be a great way to tick off that bucket list. Read about it in our blog.',
          type: 'article',
          url: 'https://www.daymade.co.uk/blog/travel-on-a-budget',
          images: [
            {
              url: `${IMAGE_DIRECTORY}/hero.jpg`,
              alt: 'girl overlooking a lake from her van',
            },
          ],
        }}
        // additionalMetaTags={[{
        //   name: 'keywords',
        //   content: 'TODO',
        // }]}
      />

      <BlogArticle
        imageDirectory={IMAGE_DIRECTORY}
        heroAltText="girl overlooking a lake from her van"
        heroImageYPosition="0%"
      >
        <>
          <h1 style={{ fontSize: '1.6em', lineHeight: '1.4em' }}>
            Travel on a budget
          </h1>

          <p className="subheading">DAYMADE to the rescue!</p>

          <div
            className="separator"
            style={{ width: '80%', marginTop: 0 }}
          />

          <p>
            Travel is an amazing way to take a break from the daily grind and
            explore new places, cultures, and experiences. Whether it’s
            exploring the ruins of Machu Picchu, relaxing on a beach in the
            Maldives, or discovering the vibrant streets of Tokyo, travelling
            allows us to broaden our horizons and learn about different parts of
            the world. However, travelling can also be quite expensive, which is
            why many people may feel like their dream holidays are out of reach.
            But what if we told you that you could win your dream holiday
            through travel competitions and the holiday lottery? In this
            article, we’ll explore how they can help make your travel dreams a
            reality.
          </p>

          <h2>The Benefits of Travelling</h2>

          <p>
            Let’s take a moment to reflect on the many benefits of travelling.
            For one, travelling allows us to learn about new cultures, try new
            foods, and experience different ways of life. It can also be a great
            way to de-stress and recharge, giving us a break from the daily
            routine. Whether you’re exploring a new city, hiking in the
            mountains, or lounging on a beach, travelling allows us to immerse
            ourselves in new surroundings and gain a fresh perspective on the
            world.
          </p>

          <h2>Travel Competitions in the UK</h2>

          <p>
            Now that we’ve established the benefits of travelling, let’s talk
            about how you can make it happen through travel competitions in the
            UK. DAYMADE offers travel competitions as a way to win a dream
            holiday or experience that might otherwise be out of reach. By
            participating in our competitions, you can enter to win a range of
            travel prizes, from luxury holidays to adventure experiences.
          </p>

          <img
            src={`${IMAGE_DIRECTORY}/secondary1.jpg`}
            alt="man on sofa calling excitedly"
            className="singleBlogImage"
          />

          <h2>A Holiday Lottery</h2>

          <p>
            DAYMADE is a (free) prize draw that can be compared to a holiday
            lottery, which offers participants the chance to win a holiday or
            experience. It works similarly to a traditional lottery, where
            participants purchase a ticket for a chance to win a prize. However,
            instead of cash, the prizes are holiday packages or experiences such
            as hot air balloon rides, wine tasting tours, or even 5 years of
            luxury holidays.
          </p>

          <img
            src={`${IMAGE_DIRECTORY}/secondary3.jpg`}
            alt="girl with confetti"
            className="singleBlogImage"
          />

          <h2>Bora Bora Holiday</h2>

          <p>
            One of the most coveted holiday destinations in the world is Bora
            Bora, a small island in French Polynesia. Known for its
            crystal-clear waters and overwater bungalows, Bora Bora is a dream
            holiday spot for many. Bora Bora is just one of many top holiday
            destinations that can be won through our holiday lottery. Other
            popular destinations include the Maldives, New York City, the
            Caribbean, and more. Whether you’re looking for a romantic getaway,
            an adventure-filled trip, or a family vacation, there are plenty of
            travel prizes available through these competitions.
          </p>

          <img
            src={`${IMAGE_DIRECTORY}/secondary2.jpg`}
            alt="man standing on top of mountain overlooking a valley with his hands up in the air"
            className="singleBlogImage"
          />

          <Separator style={{ margin: '1em 0 2.5em' }} />

          <p>
            In conclusion, by entering a holiday competition like DAYMADE,
            you’ll get a unique opportunity to win a dream holiday or experience
            that might otherwise be out of reach. By participating in our prize
            draw, you can enter to win a range of travel prizes, from luxury
            holidays to adventure experiences. So why not take a chance and see
            if you can win your dream holiday? With DAYMADE, your dream holiday
            may be just a click away. Bora Bora for the price of a coffee? Enter
            our draw here.
          </p>

          <RoundedButton
            href={getCta()?.url}
            style={{ minWidth: '180px', margin: '1em 0 1.5em' }}
          >
            Enter Now
          </RoundedButton>
        </>
      </BlogArticle>
    </MainLayout>
  );
};

export default Article;
